// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"40f20744","105":"e39d13a8","963":"8836a2ae"}[chunkId] + ".chunk.js";
};